import { AxiosPromise } from 'axios';
import Http from '../../shared/http';
import {
  Network,
  API_PATH_NETWORKS,
} from './network.types';
import { ServerResponse, WithAuditDetails } from '../types';

const http = Http.getHttp();

export function getNetworks(
  deliveryFunctionId: string,
): AxiosPromise<ServerResponse<Network>> {
  return http.get(`${API_PATH_NETWORKS}/${deliveryFunctionId}`);
}

export function createNetwork(
  deliveryFunctionId: string,
  body: WithAuditDetails<Network>,
): AxiosPromise<ServerResponse<Network>> {
  return http.post(`${API_PATH_NETWORKS}/${deliveryFunctionId}`, body);
}
